const fuf = document.querySelector< HTMLAnchorElement >( '#fuf-link' );
const params = new URLSearchParams( [
	[ 'utm_source', location.hostname ],
	[ 'utm_campaign', 'stammestemplate_v1' ],
	[ 'utm_content', 'footerbanner' ],
] );

if ( fuf ) {
	fuf.search = params.toString();
}
